<!-- 劳务公司的关注 -->
<template>
  <div class="button">
    <div v-if="isAttention" @click.stop="clickAttention(item)">
      <img style="width:20px;height:20px" src="@/assets/hideBox/yiguanzhu.png" alt />
      <span>已关注</span>
    </div>
    <div v-else @click.stop="clickAttention(item)">
      <img style="width:20px;height:20px" src="@/assets/hideBox/guanzhu.png" alt />
      <span>关注</span>
    </div>
  </div>
</template>

<script>
import { apiLaborServiceCompany } from "@/api/apiLaborServiceCompany"
import { decryptJson } from "@/utils/SpiderHack"
export default {
  name: "focus",
  inject:['cardListCom'],
  props:{
    item:{
      type:Object,
      default(){
        return {}
      }
    }
  },
  data(){
    return {
      isAttention: false
    }
  },
  // this.$store.state.user.type 0-个人，1-企业，2-组织团队，3-政府
  mounted() {
    this.userFocus()
  },
  methods: {
    //获取是否关注
    userFocus() {
      let params = {
        no: this.item.no,
        type: 0
      }
      //企业获取是否关注
      apiLaborServiceCompany.userFocus(params).then(res => {
        if (res.data && res.data.code === 200) {
          let response = res && decryptJson(res.data.payload)
          this.isAttention = JSON.parse(response)
        }
      })
    },

    // 点击关注
    clickAttention() {
      if (this.permissionTips()) return
      let params = {
        businessNo: this.item.no,
        type: 0
      }
      apiLaborServiceCompany
        .attentionHandle(params)
        .then(res => {
          if (res.data && res.data.code === 200) {
            this.isAttention = !this.isAttention
            if (this.isAttention) {
              this.$message.success("关注成功")
            } else {
              this.$message.success("取消关注成功")
            }
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .finally(() => {})
    }
  }
}
</script>

<style scoped>
</style>
